import Head from 'next/head';
import { useRouter } from 'next/router';
import { PageMetaData } from 'types/umbraco';

export function HeadMeta(meta: PageMetaData): JSX.Element {
  const router = useRouter();
  const isStaging = process.env.NEXT_PUBLIC_ENV === 'staging';
  const baseUrl = process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, '');
  const currentPath = router.asPath.split('?')[0];
  const canonical = meta.canonical || `${baseUrl}${currentPath}`;
  return (
    <Head>
      <title key="title">{meta.title || `${meta.nodeName} | Mitt Lager`}</title>
      {meta.description && (
        <meta key="description" name="description" content={meta.description} />
      )}
      <meta
        name="google-site-verification"
        content="eNTtNtnH3bxo5VqpHq-VD5uqo1dlWtU5YtLnImMd3wo"
      />
      <link rel="canonical" href={canonical} />
      {isStaging && <meta name="robots" content="noindex, nofollow" />}
    </Head>
  );
}
